import styled from "styled-components";
import mediaQueries from "./Theme/mediaQueries";
import { heading1, heading2, heading5Alt } from "./Typography";

type Center = "none" | "all" | "mobile" | "desktop";

const Container = styled.h2<{ center?: Center }>`
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
    text-align: ${({ center }) => (center == "all" || center == "mobile" ? "center" : "left")};

  ${mediaQueries.md()} {
    text-align: ${({ center }) => (center == "all" || center == "desktop" ? "center" : "left")};
  }
}
`;

const FirstPart = styled.span`
  ${heading5Alt}
  display: block;
`;

const SecondPart = styled.span<{ variant?: "large" | "normal" }>`
  display: block;
  ${({ variant }) => (variant === "normal" ? heading2 : heading1)};
`;

const SectionTitle = ({
  firstPart,
  secondPart,
  variant = "large",
  center = "desktop",
  ...props
}: {
  firstPart: string;
  secondPart: string;
  variant?: "large" | "normal";
  center?: Center;
  className?: string;
}) => (
  <Container className={props.className} center={center}>
    <FirstPart>{firstPart}</FirstPart>
    <SecondPart variant={variant}>{secondPart}</SecondPart>
  </Container>
);

export default SectionTitle;
